import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/canteen/inventory/group",
        component: List,
        name: "inventory.group",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/group/create",
        component: Create,
        name: "inventory.group.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/group/:id/edit",
        component: Edit,
        name: "inventory.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
